$( document ).ready(function() {
	$('.js-hmbanner').slick({
		arrows: true,
		dots: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		horizontal: true,
		infinite: true,
		autoplay: true,
		fade: true,
		pauseOnHover: false,
		autoplaySpeed: 5000,
		responsive: [
			{
				breakpoint: 601,
				settings: {
					arrows: false,
					dots: false
				}
			}
		]
	});
    
    // trust factor
    $('.keyfeature-ul').slick({
			arrows: true,
			dots: false,
			slidesToShow: 4,
			slidesToScroll: 1,
			horizontal: true,
			infinite: true,
			autoplay: true,
			pauseOnHover: false,
			autoplaySpeed: 3000,
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 3
					}
				},
                {
					breakpoint: 992,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 576,
					settings: {
						slidesToShow: 1
					}
				}
			]
		});
    
    // WHAT CUSTOMERS
    /*$('.sport-ul').slick({
			arrows: true,
			dots: false,
			slidesToShow: 5,
			slidesToScroll: 1,
			horizontal: true,
			infinite: true,
			autoplay: true,
			pauseOnHover: false,
			autoplaySpeed: 3000,
			responsive: [
				{
					breakpoint: 1440,
					settings: {
						slidesToShow:3
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2
					}
				}
			]
		});*/
    
    /**/
     $('.icon-ul').slick({
			arrows: true,
			dots: false,
			slidesToShow: 10,
			slidesToScroll: 1,
			horizontal: true,
			infinite: true,
			autoplay: true,
			pauseOnHover: false,
			autoplaySpeed: 3000,
			responsive: [
				{
					breakpoint: 1440,
					settings: {
						slidesToShow:8
					}
				},
				{
					breakpoint:1200,
					settings: {
						slidesToShow:6
					}
				},
                {
					breakpoint:992,
					settings: {
						slidesToShow:4
					}
				},
                {
					breakpoint:576,
					settings: {
						slidesToShow : 3,
                        centerMode : true,
                        centerPadding : '70px'
					}
				},
                {
					breakpoint:480,
					settings: {
						slidesToShow : 3,
                        centerMode : true,
                        centerPadding : '40px'
					}
				}
			]
		});
        
    
        /* best seller tab */
        $('#bst-seller-tab').easyResponsiveTabs({
            type:'default',
            activate:function(){}
        });
        $('#bst-seller-tab .product_list').slick({
			arrows: true,
			dots: false,
			slidesToShow: 5,
			slidesToScroll: 1,
			horizontal: true,
			infinite: true,
			autoplay: true,
			pauseOnHover: false,
			autoplaySpeed: 3000,
			responsive: [
				{
					breakpoint: 1440,
					settings: {
						slidesToShow: 4
					}
				},
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 3
					}
				},
                {
					breakpoint: 991,
					settings: {
						slidesToShow: 2
					}
				}
			]
		});
        $("#bst-seller-tab ul>li").on('click', function () { 		
            $('#bst-seller-tab .bst-tab .product_list').slick('refresh');   
        });
        
        /* feature product*/
         $('#f-product-tab').easyResponsiveTabs({
            type:'default',
            activate:function(){}
        });
        $('#f-product-tab .product_list').slick({
			arrows: true,
			dots: false,
			slidesToShow: 5,
			slidesToScroll: 1,
			horizontal: true,
			infinite: true,
			autoplay: true,
			pauseOnHover: false,
			autoplaySpeed: 3000,
			responsive: [
				{
					breakpoint: 1440,
					settings: {
						slidesToShow: 4
					}
				},
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 3
					}
				},
                {
					breakpoint: 768,
					settings: {
						slidesToShow: 2
					}
				}
			]
		});
        $("#f-product-tab ul>li").on('click', function () { 		
            $('#f-product-tab .bst-tab .product_list').slick('refresh');   
        });
        

});
